<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AddCredentialsFlow from '../../../credentials-settings/add-credentials-flow/AddCredentialsFlow';
import MergeInvestigation from './MergeInvestigation';

export default {
  name: 'MergeInvestigationFlow',
  computed: {
    ...mapState('mergeInvestigationQuestions', ['sourceNameToAdd', 'onCredentialsAddSuccess']),
  },
  created() {
    this.openMergeInvestigation();
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal', 'closeModal']),
    openAddCredentialsFlow() {
      this.openModal({
        component: AddCredentialsFlow,
        props: {
          sourceNameToAdd: this.sourceNameToAdd,
          allowBackToSourceSelection: false,
        },
        eventHandlers: {
          success: () => {
            this.onCredentialsAddSuccess();
          },
        },
        popupAlignment: 'full-screen',
      });
    },
    openMergeInvestigation() {
      this.openModal({
        component: MergeInvestigation,
        eventHandlers: {
          close: this.closeFlow,
          done: () => this.$emit('done'),
          'add-credentials-clicked': () => {
            this.openAddCredentialsFlow();
          },
        },
      });
    },
    closeMergeInvestigation() {
      this.closeModal();
    },
    closeFlow() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>

</style>
